import { useTranslation } from 'react-i18next';
import { Button } from 'shared-ui/lib/components/Button';
import { TableColumn } from 'shared-ui/lib/customs/react/generic-table/TableColumn';
import { formatDateTime } from 'shared-ui/lib/utils/format-date';
import { PartnerCustomerInvitesQuery } from '../generated/graphql';

type InviteRow = PartnerCustomerInvitesQuery['partnerCustomerInvites'][0];

const CancelInviteButton = ({
  invite,
  onCancel,
}: {
  invite: InviteRow;
  onCancel: (invite: InviteRow) => void;
}): JSX.Element => {
  const { t } = useTranslation('ServiceCallCustomersScene');

  return (
    <Button type="button" onClick={() => onCancel(invite)}>
      {t('cancelInvite')}
    </Button>
  );
};

const businessName: TableColumn = {
  field: 'businessName',
  text: 'ServiceCallCustomersScene:businessName',
};

const email: TableColumn = {
  field: 'email',
  text: 'ServiceCallCustomersScene:inviteEmail',
};

const createdAt: TableColumn = {
  field: 'createdAt',
  text: 'ServiceCallCustomersScene:createdAt',
  formatter: (data: InviteRow) => formatDateTime(data.createdAt),
};

const cancelInvite = (onCancel: (invite: InviteRow) => void): TableColumn => ({
  field: 'id',
  text: 'ServiceCallCustomersScene:cancelInvite',
  formatter: (data: InviteRow) => <CancelInviteButton invite={data} onCancel={onCancel} />,
});

export const partnerCustomerInviteColumns = {
  businessName,
  email,
  createdAt,
  cancelInvite,
};
